const BASE_URL = "https://apisbtc.angelorusharena.com/api";

export default BASE_URL;